<div class="rcm-grid">
  <nova-table
    ariaLabel="Notary schedule by time slot"
    density="small"
    [contained]="true"
    [stickyColumn]="true"
    [responsive]="true"
    additionalClasses="nova-table--sticky-header rcm-grid__table"
    wrapperAdditionalClasses="rcm-grid__wrapper"
  >
    <colgroup>
      <col [style.width]="laneColumnWidth" />
      <col [style.width]="arrowColumnWidth" />
      <col
        *ngFor="let column of visibleColumns; trackBy: trackBySlotIndex"
        [style.width]="column.index === currentSlotColumnIndex ? currentColumnWidth : slotColumnWidth"
      />
      <col [style.width]="arrowColumnWidth" />
    </colgroup>

    <thead novaTableHead>
      <tr novaTableHeadRow>
        <th novaTableColumn scope="col" class="rcm-grid__lane-head">Notary</th>
        <td class="rcm-grid__arrow-head">
          <button
            type="button"
            class="rcm-grid__arrow"
            aria-label="Earlier time slots"
            [disabled]="!canPageBack"
            (click)="pageBy(-1)"
          >
            <nova-icon name="arrow_back" size="small"></nova-icon>
          </button>
        </td>
        <th
          novaTableColumn
          scope="col"
          class="rcm-grid__slot-head"
          *ngFor="let column of visibleColumns; trackBy: trackBySlotIndex"
          [class.rcm-grid__slot-head--current]="column.index === currentSlotColumnIndex"
          [attr.aria-current]="column.index === currentSlotColumnIndex ? 'time' : null"
        >
          <span class="rcm-grid__slot-time">{{ column.label }}</span>
          <span class="rcm-grid__slot-meridiem">{{ column.meridiem }}</span>
          <span class="rcm-grid__sr-only" *ngIf="column.index === currentSlotColumnIndex">
            current time slot
          </span>
        </th>
        <td class="rcm-grid__arrow-head">
          <button
            type="button"
            class="rcm-grid__arrow"
            aria-label="Later time slots"
            [disabled]="!canPageForward"
            (click)="pageBy(1)"
          >
            <nova-icon name="arrow_forward" size="small"></nova-icon>
          </button>
        </td>
      </tr>
    </thead>

    <tbody novaTableBody>
      <ng-container *ngFor="let row of rows; trackBy: trackByLaneId">
        <tr
          novaTableRow
          [attr.data-lane-id]="row.lane.laneId"
          [class.rcm-grid__row--match]="row.isMatch"
        >
          <th scope="row" class="rcm-grid__lane nova-table__cell">
            <span class="rcm-grid__lane-name">{{ row.lane.name }}</span>
            <span class="rcm-grid__lane-tags">
              <nova-tag *ngIf="row.lane.segment" size="small">{{ row.lane.segment }}</nova-tag>
              <nova-tag
                *ngIf="row.lane.status"
                size="small"
                [variant]="row.lane.status.tagVariant"
                >{{ row.lane.status.label }}</nova-tag
              >
            </span>
          </th>
          <td novaTableCell class="rcm-grid__spacer"></td>
          <td
            novaTableCell
            *ngFor="let cell of row.cells; trackBy: trackByCellKey"
            class="rcm-grid__cell"
            [class.rcm-grid__cell--current]="cell.isCurrent"
            [attr.data-package-id]="cell.packageId"
          >
            <app-slot-pill
              [presentation]="cell.presentation"
              [interactive]="cell.interactive"
              [expanded]="cell.expanded"
              [controls]="cell.controls"
              (activate)="onPillActivate(cell)"
            ></app-slot-pill>
          </td>
          <td novaTableCell class="rcm-grid__spacer"></td>
        </tr>

        <tr
          class="rcm-grid__panel-row"
          *ngFor="let panel of row.panels; trackBy: trackByPanelId"
        >
          <td class="rcm-grid__panel-cell" [attr.colspan]="panelColumnSpan">
            <app-order-detail-panel
              [panelId]="panel.panelId"
              [variant]="panel.variant"
              [nextSlot]="panel.nextSlot"
              [ariaLabel]="panel.ariaLabel"
              [entry]="entryFor(panel.packageId)"
              (retry)="panelRetry.emit(panel.packageId)"
              (dismiss)="onPanelDismiss(panel.packageId)"
            ></app-order-detail-panel>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nova-table>

  <p class="rcm-grid__empty" *ngIf="rows.length === 0">
    No notaries scheduled for this day.
  </p>
</div>
